"use strict";

// Obligaciones de nomina. Mismo criterio que el backend
// (noataga/src/domains/payroll-coverage.js): activo = no excluido y, para
// vehiculos, no borrado. Los vehiculos borrados no se muestran.

import moment from "moment";

const idOf = value => String(value && value._id ? value._id : value);

const payrollMembers = list => {
  const members = (list || []).filter(m => !m.isDeleted);
  return {
    active: members.filter(m => !m.isExcluded),
    inactive: members.filter(m => m.isExcluded)
  };
};

const isExcludedFrom = (obligation, member) =>
  (obligation.excludedReferences || []).map(idOf).indexOf(idOf(member)) > -1;

// { employees, vehicles } segun las etiquetas de nomina de la obligacion, o
// null si no lleva ninguna. Solo las obligaciones de la contratista.
const payrollScope = (obligation, tagCatalogById, contractorObligationType) => {
  if (!obligation || obligation.type !== contractorObligationType) return null;
  const tags = (obligation.tags || [])
    .map(t => tagCatalogById[idOf(t)])
    .filter(t => t && t.payroll && (t.payroll.employees || t.payroll.vehicles));
  if (!tags.length) return null;
  return {
    employees: tags.some(t => t.payroll.employees),
    vehicles: tags.some(t => t.payroll.vehicles)
  };
};

// Por que no se puede tildar la nomina, o null si se puede. Misma regla que
// isCoverageLocked en noataga/src/domains/payroll-coverage.js.
const payrollLockMessage = (obligation, { STATUS, DUEDATE_TYPES }) => {
  if (!obligation.dueDate) return "Esta obligación nunca fue presentada";
  const pastDue = obligation.dueDateType !== DUEDATE_TYPES.ONCE &&
    moment(obligation.dueDate).isBefore(moment(), "day");
  return obligation.status === STATUS.DELAYED || pastDue ? "Esta obligación está vencida" : null;
};

// Cuantos activos del alcance no estan tildados.
const uncoveredCount = (obligation, contractor, scope) => {
  if (!scope || !contractor) return 0;
  const covered = (obligation.coveredReferences || []).map(idOf);
  const missing = list => payrollMembers(list).active
    .filter(m => !isExcludedFrom(obligation, m) && covered.indexOf(idOf(m)) === -1).length;
  return (scope.employees ? missing(contractor.employees) : 0) +
    (scope.vehicles ? missing(contractor.vehicles) : 0);
};

export { payrollMembers, payrollScope, uncoveredCount, isExcludedFrom, payrollLockMessage };
